// extracted by mini-css-extract-plugin
export default {"pageContainer":"R7Jg6n1anLdyKc3ZVqOw__pageContainer___"};